import { type InstrumentPlayerProps } from "../playerTypes";

export function DidgeridooPlayer(props: InstrumentPlayerProps) {
  return (
    <div className="instrument-ui didgeridoo-ui" data-testid="instrument-player-yidaki_didgeridoo">
      <div className="didgeridoo-tube" aria-label="Yidaki didgeridoo drone tube" data-control-target="didgeridoo-drone">
        <button type="button" className="drone-mouth" aria-label="Toggle didgeridoo drone" onClick={() => props.onControl("didgeridoo_drone")}>Drone</button>
        <span className="tube-body" />
      </div>
      <div className="instrument-control-strip">
        <button type="button" aria-label="Toggle circular breath hold mode" onClick={() => props.onControl("circular_hold", true)}>Circular breath hold</button>
        <div className="xy-pad" data-testid="didgeridoo-xy-pad" data-control-target="didgeridoo-mouth" role="slider" aria-label="Didgeridoo mouth shape XY pad" aria-valuemin={0} aria-valuemax={100} aria-valuenow={50} tabIndex={0} onPointerDown={(event) => {
          const box = event.currentTarget.getBoundingClientRect();
          props.onControl("breath_pressure", (event.clientX - box.left) / box.width);
          props.onControl("mouth_shape_y", (event.clientY - box.top) / box.height);
        }} onKeyDown={(event) => {
          if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            props.onControl("breath_pressure", event.key === "ArrowUp" ? 0.78 : 0.32);
          }
          if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
            event.preventDefault();
            props.onControl("mouth_shape_y", event.key === "ArrowRight" ? 0.72 : 0.28);
          }
        }}>
          <span>Mouth XY</span>
        </div>
        <label className="surface-slider"><span>Vocalization</span><input aria-label="Didgeridoo vocalization layer" type="range" min="0" max="1" step="0.01" defaultValue="0.28" onInput={(event) => props.onControl("vocalization", Number(event.currentTarget.value))} /></label>
      </div>
      <p className="instrument-note caution-inline">Cultural caution: Traditional Yidaki and modern didgeridoo contexts are distinct.</p>
    </div>
  );
}
